module.exports = __webpack_public_path__ + "img/nabl_gallery15.41f94e4d.jpg";